import NotFound from '@/components/NotFound'
import { useUrgentSystemNews } from '@/hooks/useSystemNews'
import { CatchBoundary, Outlet, createFileRoute, useLoaderData } from '@tanstack/react-router'
import clsx from 'clsx'

export const Route = createFileRoute('/_protected/_import')({
    component: ImportLayout
})

function ImportLayout() {
    const { user } = useLoaderData({ from: "/_protected" })

    if (!user.products.import) {
        return (
            <NotFound />
        )
    }
    const {hasUrgentSystemNews} = useUrgentSystemNews()

    return (
        <>
            <div className="lg:hidden bg-white shadow h-16 fixed top-0 w-full z-30"></div>
            <main className={clsx("lg:pt-20 pt-16 w-full flex-1 flex flex-col", hasUrgentSystemNews && "lg:pt-[104px]")}>
                <div className="rounded-lg flex-1 flex flex-col">
                    <CatchBoundary
                        getResetKey={() => 'reset'}
                        onCatch={(error) => console.error(error)}
                    >
                        <Outlet />
                    </CatchBoundary>
                </div>
            </main>

        </>
    )
}
